module.exports = __webpack_public_path__ + "img/qrcode.420d0505.png";